<div class="product-card flex flex-col w-full rounded-lg overflow-hidden cursor-pointer" (click)="onCardClick()">
  <div class="h-[7rem] w-full bg-[#E6F2F1] relative">
    @if (displayImage(); as imageUrl) {
      <img class="w-full h-full object-cover" [src]="imageUrl" [alt]="name()" (error)="onImageError()" />
    } @else {
      <div
        class="w-full h-full flex items-center justify-center text-[#8A8E94]"
        role="img"
        [attr.aria-label]="name()"
        data-testid="product-image-fallback"
      >
        <svg aria-hidden="true" width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path
            d="M4 5.75C4 4.78 4.78 4 5.75 4h12.5C19.22 4 20 4.78 20 5.75v12.5c0 .97-.78 1.75-1.75 1.75H5.75C4.78 20 4 19.22 4 18.25V5.75Z"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path d="m6.5 17 3.25-3.5 2.5 2.5 1.75-2 3.5 3" stroke="currentColor" stroke-width="1.5" />
          <circle cx="9" cy="9" r="1.25" fill="currentColor" />
        </svg>
      </div>
    }
    @if (isFavorite()) {
      <i class="absolute top-3 right-3 z-2" (click)="markAsFavorite($event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M12.8197 4.57717L11.999 5.39968L11.1757 4.57643C9.07663 2.47736 5.67336 2.47736 3.5743 4.57643C1.47523 6.67549 1.47523 10.0787 3.5743 12.1778L11.4697 20.0731C11.7626 20.366 12.2375 20.366 12.5304 20.0731L20.4318 12.1763C22.5262 10.0703 22.5298 6.67662 20.4304 4.57717C18.3275 2.47428 14.9226 2.47428 12.8197 4.57717Z"
            fill="#CB2222"
          />
        </svg>
      </i>
    } @else {
      <i class="absolute top-3 right-3 z-2" (click)="markAsFavorite($event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M12.8197 4.57717L11.999 5.39968L11.1757 4.57643C9.07663 2.47736 5.67336 2.47736 3.5743 4.57643C1.47523 6.67549 1.47523 10.0787 3.5743 12.1778L11.4697 20.0731C11.7626 20.366 12.2375 20.366 12.5304 20.0731L20.4318 12.1763C22.5262 10.0703 22.5298 6.67662 20.4304 4.57717C18.3275 2.47428 14.9226 2.47428 12.8197 4.57717ZM19.3682 11.1186L12 18.4822L4.63496 11.1171C3.12167 9.60385 3.12167 7.15037 4.63496 5.63709C6.14824 4.1238 8.60175 4.1238 10.1151 5.63709L11.4725 6.99453C11.7704 7.2924 12.2551 7.28659 12.5457 6.98168L13.8804 5.63783C15.3975 4.12073 17.8526 4.12073 19.3697 5.63783C20.8834 7.15148 20.8808 9.59775 19.3682 11.1186Z"
            fill="#AFB2B6"
          />
        </svg>
      </i>
    }
    @if (label()) {
      <div class="absolute top-3 left-3 z-2">
        @if (label() === 'new') {
          <app-tag type="warning">{{ 'rewards.new' | translate }}</app-tag>
        }
        @if (label() === 'promo') {
          <app-tag type="error">{{ 'rewards.promo' | translate }}</app-tag>
        }
      </div>
    }
  </div>
  <div class="flex flex-col px-4 py-2 gap-2 bottom">
    <span class="min-w-0 truncate">{{ name() }}</span>
    <div class="w-min">
      <app-tag type="success">{{ category() }}</app-tag>
    </div>
    <span class="text-[0.9375rem]">
      <span class="text-[#017F70] font-bold">{{ price() | number: '1.0-0' }} </span>
      <span class="text-[#505760] font-medium">{{ 'rewards.ganas' | translate }}</span>
    </span>
  </div>
</div>
